import { useBlockProps, useInnerBlocksProps } from "@wordpress/block-editor";

const ALLOWED_BLOCKS = ["brandy/button"];
const TEMPLATE = [["brandy/button"]];

/**
 * Mirrors save.jsx exactly — same element, same class list — so the editor
 * preview and the saved markup resolve to the same layout rules.
 *
 * No `orientation` is passed to useInnerBlocksProps: layout support owns
 * orientation, and hardcoding it here would fight the toolbar's own control.
 */
export default function Edit() {
  const blockProps = useBlockProps({ className: "wp-block-buttons" });
  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    allowedBlocks: ALLOWED_BLOCKS,
    template: TEMPLATE,
    templateInsertUpdatesSelection: true,
  });

  return <div {...innerBlocksProps} />;
}
